import { ArrowUpRight } from "lucide-react";
import { RevealText, FadeIn } from "../motion/Reveal";
import { SectionLabel } from "../motion/SectionLabel";
import { PARTNERS_SECTION, GEN } from "../../data/content";

export const Partners = ({ onContact }) => {
  return (
    <section
      id="partners"
      data-testid="partners-section"
      className="relative min-h-screen flex flex-col justify-center py-28 md:py-32 px-6 md:px-10 bg-[#0a0a0a] border-y border-white/10 overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 -z-0">
        <img
          src={GEN.partners}
          alt=""
          aria-hidden
          className="h-full w-full object-cover opacity-[0.22]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0a0a0a]/85 to-[#0a0a0a]" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto w-full">
        <div className="max-w-4xl mb-16">
          <SectionLabel>{PARTNERS_SECTION.label}</SectionLabel>
          <RevealText
            as="h2"
            lines={["Let's build the next", "generation of", "entertainment together."]}
            className="mt-6 font-display font-bold text-white text-4xl sm:text-5xl lg:text-6xl leading-[1] tracking-tight"
          />
          <FadeIn delay={0.2}>
            <p className="mt-6 font-body text-lg text-neutral-400 leading-relaxed font-light">
              {PARTNERS_SECTION.lead}
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-white/10">
          {PARTNERS_SECTION.types.map((t, i) => (
            <FadeIn
              key={t}
              delay={(i % 3) * 0.08}
              className="group relative flex items-center justify-between gap-4 border-b border-r border-white/10 p-8 md:p-10 hover:bg-white/[0.03] transition-colors duration-500"
              data-testid={`partner-type-${i}`}
            >
              <div className="flex items-baseline gap-4">
                <span className="font-serif-italic text-2xl text-[#ff8c00]/60">
                  0{i + 1}
                </span>
                <h3 className="font-display font-medium text-xl md:text-2xl text-white tracking-tight">
                  {t}
                </h3>
              </div>
              <ArrowUpRight
                size={20}
                className="text-neutral-600 transition-all duration-300 group-hover:text-[#ff4500] group-hover:-translate-y-1 group-hover:translate-x-1"
              />
            </FadeIn>
          ))}
        </div>

        <div className="mt-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <FadeIn className="max-w-2xl">
            <p className="font-body text-xl md:text-2xl text-neutral-300 leading-relaxed font-light">
              {PARTNERS_SECTION.closer}
            </p>
          </FadeIn>
          <FadeIn delay={0.1}>
            <button
              onClick={onContact}
              data-testid="partners-cta"
              className="group inline-flex items-center gap-2 rounded-full bg-white text-black font-body font-medium px-7 py-4 hover:bg-[#ff4500] hover:text-white transition-[transform,background-color,color,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-12px_rgba(255,69,0,0.55)] whitespace-nowrap"
            >
              Start the conversation
              <ArrowUpRight
                size={18}
                className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
            </button>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};
